<template>
    <div class="position-relative">
        <v-zoomer
            ref="zoomer"
            :zoomed.sync="zoomed"
            class="mb-3 shadow-sm border"
            :limit-translation="false"
        >
            <img :src="src" class="img-fluid rounded" alt="Legenda RTS" />
        </v-zoomer>
        <b-button
            v-if="zoomed"
            variant="light"
            class="position-absolute"
            style="right: 5px; top: 5px"
            @click="reset"
            >Remover zoom
        </b-button>
        <div class="text-secondary font-weight-light zoomer-tip">
            <p>Utilize o mouse para interagir com a imagem:</p>
            <ul>
                <li>Scroll do mouse para dar zoom.</li>
                <li>Clique o botão esquerdo do mouse e arraste para mover.</li>
                <li>
                    Clique no botão "Remover zoom" no canto superior direito
                    para voltar ao estado original.
                </li>
                <li>Duplo clique na imagem para aplicar ou remover zoom.</li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { Sources } from "@/modules/common/settings";
import { RTS_IMAGE as CAMPOS_NOVOS_RTS_IMAGE } from "@/modules/campos_novos/settings";
import { RTS_IMAGE as FOZ_CHAPECO_RTS_IMAGE } from "@/modules/foz_chapeco/settings";
import { RTS_IMAGE as JULHO_14_RTS_IMAGE } from "@/modules/julho_14/settings";

const images = {
    [Sources.CAMPOS_NOVOS]: CAMPOS_NOVOS_RTS_IMAGE,
    [Sources.FOZ_CHAPECO]: FOZ_CHAPECO_RTS_IMAGE,
    [Sources.JULHO_14]: JULHO_14_RTS_IMAGE
};

export default {
    name: "RtsLegend",
    data() {
        return {
            zoomed: false
        };
    },
    computed: {
        ...mapState("common", ["source"]),
        src() {
            return images[this.source];
        }
    },
    methods: {
        reset() {
            this.zoomed = false;
            this.$refs.zoomer.reset();
        }
    }
};
</script>

<style lang="scss" scoped>
.zoomer-tip {
    font-size: 0.875rem;
    p {
        margin-bottom: 0.5rem;
    }
}
</style>
